<template>
  <div class="loginfo-container">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true" :model="filters">
        <el-form-item label="锻炼营">
          <enumSelector2 :options="$config.traningType" style="width: 200px" v-model="filters.traningType" />
        </el-form-item>
        <el-form-item label="关键字">
          <el-input size="small" v-model="filters.search" placeholder="姓名，手机号关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" v-on:click="queryPageList">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table stripe border size="mini" :data="tableData" highlight-current-row expand-on-click-node="false"
      style="width: 100%">
      <el-table-column prop="TraningType" label="锻炼营" min-width="100" sortable>
        <template slot-scope="scope">
          {{ format.traningTypeFormat(scope.row.TraningType) }}
        </template>
      </el-table-column>
      <el-table-column prop="Member" label="姓名" min-width="100" sortable> <template slot-scope="scope">
          <div class="link" v-if="scope.row.Member">
            {{ scope.row.Member.RealName }} <el-tag type="primary">{{ scope.row.Member.Mobile }}</el-tag>
          </div>
        </template></el-table-column>
         <el-table-column prop="AppointDate" label="报名起始日期" min-width="120" sortable>
        <template slot-scope="scope">
          <el-tag type="info">{{ format.dateFormat(scope.row.AppointDate) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="ScheduleBeginDate" label="完整开始日期" min-width="100" sortable>
        <template slot-scope="scope">
          <el-tag type="success">{{ format.dateFormat(scope.row.ScheduleBeginDate) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="ScheduleEndDate" label="完整结束日期" min-width="100" sortable>
        <template slot-scope="scope">
          <el-tag type="danger">{{ format.dateFormat(scope.row.ScheduleEndDate) }}</el-tag>
        </template>
      </el-table-column>
     
      <el-table-column prop="Count" label="锻练记录次数" min-width="120" sortable>
      </el-table-column>
      <el-table-column prop="InsertTime" label="创建时间" width="130" sortable>
        <template slot-scope="scope">
          {{ format.dateTimeFormat(scope.row.InsertTime) }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" :width="100" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-sizes="pageSizesList" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total" :current-page.sync="pageIndex"></el-pagination>
    </div>
  </div>
</template>
<script>
import dateSelector from "@/components/dateSelector";
import enumSelector2 from "@/components/enumSelector2.vue";
import { GetScheduleList, DelSchedule } from "@/api/traning/traning";
export default {
  components: {
    dateSelector,
    enumSelector2
  },
  data() {
    return {
      filters: {
        search: "",
        traningType: "",
      },
      tableData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      pageSizesList: [10, 15, 20, 30, 50],
    };
  },
  methods: {
    queryPageList: function () {
      let data = {
        pageSize: this.pageSize,
        traningType: this.filters.traningType ? this.filters.traningType : "",
        pageIndex: this.pageIndex,
        search: this.filters.search,
      };
      GetScheduleList(data).then((response) => {
        this.listLoading = false;
        if (response) {
          this.tableData = response.Items;
          this.total = response.Total || response.Items.length;
        }
      });
    },
    handleSizeChange(val) {
      var pageSize = `${val}`;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.queryPageList());
    },
    handleCurrentChange(val) {
      this.pageIndex = `${val}`;
      this.queryPageList();
    },
    handleDelete(row) {
      this.$confirm("确认删除该训练计划吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let parma = { key: row.Key };
        DelSchedule(parma).then((res) => {
          if (res) {
            this.queryPageList();
          }
        });
      });
    },
  },
  mounted() {
    this.queryPageList();
  },
};
</script>

<style lang='scss' scoped>
.loginfo-container {
  padding: 10px;
}

/deep/.el-dialog {
  margin-top: 10px !important;
}
</style>
